import { styled } from '@mui/material'
import { colorPalette } from '../../style/colorPalette'

// 単票とプロジェクト計画で候補のグループ見出しの見た目を揃えるため、両方からここを参照する。
export const OptionGroupHeader = styled('div', {
  shouldForwardProp: prop => prop !== 'collapsible',
})(({ collapsible }: { collapsible: boolean }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '2px 8px',
  cursor: collapsible ? 'pointer' : 'default',
  fontSize: '0.75rem',
  color: colorPalette.monotone[4],
  borderTop: `1px solid ${colorPalette.monotone[2]}`,
  '&:hover': collapsible
    ? { backgroundColor: colorPalette.monotone[1] }
    : undefined,
}))
